import styled from 'styled-components';
import { LayoutAddiScreenMobileLargeMax } from '@addi/foundation/dist/web/layout';
import { SizeAddiFontBase, SizeAddiFontLarge, SizeAddiFontSmall, } from '@addi/foundation/dist/web/sizes';
import { ColorAddiCompFiveLighten1, ColorAddiPrimaryActive, } from '@addi/foundation/dist/web/colors';
import { FontAddiWeightRegular } from '@addi/foundation/dist/web/fonts';
import { Paragraph, Title } from '../Typpographies.styled';
export const TitlesContainer = styled.div ``;
export const TitleSectionPage = styled(Title) `
  margin: 0px;
  &&& {
    font-size: ${SizeAddiFontSmall};
  }

  line-height: 19.2px;
  @media (min-width: ${LayoutAddiScreenMobileLargeMax}) {
    line-height: 40.96px;
    &&& {
      font-size: ${SizeAddiFontLarge};
    }
  }
`;
export const Line = styled.div `
  width: 40px;
  height: 2px;
  margin-top: 4px;
  background-color: ${({ backgroundColor }) => backgroundColor ? backgroundColor : ColorAddiCompFiveLighten1};
  @media (min-width: ${LayoutAddiScreenMobileLargeMax}) {
    width: 45px;
    height: 4px;
  }
`;
export const TitleContainer = styled.div ``;
export const LinkText = styled(Paragraph) `
  text-decoration: none;
  cursor: pointer;
  font-weight: ${FontAddiWeightRegular};
  font-size: ${SizeAddiFontSmall};
  line-height: 23.68px;
  color: ${ColorAddiPrimaryActive};
  @media (min-width: ${LayoutAddiScreenMobileLargeMax}) {
    line-height: 29.6px;
    font-size: ${SizeAddiFontBase};
  }
`;
//# sourceMappingURL=section-title-with-line.styled.js.map